module.exports = __webpack_public_path__ + "img/login-01.1b43e0a0.png";